module.exports = __webpack_public_path__ + "static/media/grants.1f6cf6ab.jpeg";